import React from "react";

export default function EscalabilidadeBusiness() {
  return (
    <section className="text-white bg-[#040116]">
      <div className="container mx-auto max-w-[1080px] flex flex-col md:flex-row items-center md:items-start md:justify-between gap-8 md:gap-28 py-16 md:py-30 px-4 md:px-0 font-inter-regular">
        <div className="w-full md:w-1/3 text-center md:text-left">
          <h2 className="inline-block text-[32px] md:text-5xl mb-6 md:mb-0 leading-[1.2] md:leading-[1]">
            Da pesquisa à{" "}
            <span className="bg-gradient-to-r from-[#4B3BDB] via-[#A002CB] to-[#FC0021] text-transparent bg-clip-text">
              escalabilidade
            </span>
          </h2>
        </div>
        <div className="w-full md:w-2/3 text-center md:text-left px-8 md:px-0">
          <p className="leading-relaxed text-xl">
            Lideramos a implementação de metodologias e soluções ágeis personalizadas, conectando inovação e melhoria contínua para que seus projetos superem expectativas e gerem resultados de alto valor.
          </p>
        </div>
      </div>
    </section>
  );
}
